import { LoginPayload, LoginResponse, LoginByEmailPayload } from './interfaces';
import { usePost } from '@selfserve/react-hooks';

import { apiEndpoints } from '@selfserve/react-utils';

export const useLoginRequest = () =>
  usePost<LoginPayload, LoginResponse>(apiEndpoints.login);

export const useLoginByEmailRequest = () =>
  usePost<LoginByEmailPayload, any>(apiEndpoints.loginByEmail);

export * from './interfaces';
export * from './schemas';
